/**
 * Secure token storage utility.
 * Uses sessionStorage primarily, with localStorage fallback for migration.
 * Migrates tokens from localStorage → sessionStorage on first read.
 */

const memoryStore = {};

function getSessionStorage() {
  try {
    sessionStorage.setItem('__test', '1');
    sessionStorage.removeItem('__test');
    return sessionStorage;
  } catch {
    return null;
  }
}

const session = getSessionStorage();

export function getToken(key) {
  if (session) {
    const val = session.getItem(key);
    if (val) return val;
    // Migrate from localStorage if exists
    try {
      const lsVal = localStorage.getItem(key);
      if (lsVal) {
        session.setItem(key, lsVal);
        localStorage.removeItem(key);
        return lsVal;
      }
    } catch {}
    return null;
  }
  return memoryStore[key] || null;
}

export function setToken(key, value) {
  if (session) {
    session.setItem(key, value);
  } else {
    memoryStore[key] = value;
  }
}

export function removeToken(key) {
  if (session) {
    session.removeItem(key);
  } else {
    delete memoryStore[key];
  }
  // Also clean from localStorage
  try { localStorage.removeItem(key); } catch {}
}

export function clearTokens(keys) {
  keys.forEach((key) => {
    removeToken(key);
  });
}
